export default __webpack_public_path__ + "static/Ziegler_Logo_RGB_Claim_weiss-ebfe5cfe2864d58b21c68bb9c584e22d.svg";